import { render, staticRenderFns } from "./HasDamagesQuestion.vue?vue&type=template&id=4642761d&scoped=true"
import script from "./HasDamagesQuestion.vue?vue&type=script&lang=ts"
export * from "./HasDamagesQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4642761d",
  null
  
)

export default component.exports